import React from "react";
import Dropdown from "../form/dropDown";
import { buyBackPeriodList, productCategoryList } from "constants/global";
import { formatMoney } from "utilities/formatMoney";
import { SearchInput as InputField } from "../TableSearchInput";
import QuestionHelpIcon from "../QuestionHelpIcon";
import CurrencyToggle from "../currencyToggle";
import { selectedCountryStateOrProvince, wareHouseCountryList } from "constants/FinanceConstants";

const InventoryFinanceForm = ({
  productCategory,
  setProductCategory,
  productType,
  setProductType,
  wareHouseLocation,
  setWareHouseLocation,
  province,
  setProvince,
  isBusinessApproved,
  business,
  setBuyBackAmount,
  buyBackAmount,
  isBuyBackValid,
  buyBackPeriod,
  setBuyBackPeriod,
  buyBackMaxAmount,
  newWalletsData,
  isLoadingNewWallets,
  refetchNewWallets
}) => {
  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <div className="w-1/2">
          <Dropdown
            value={productCategory}
            options={Object.keys(productCategoryList).map((option) => ({
              label: option,
              value: option,
            }))}
            onChange={(value) => setProductCategory(value)}
            label="Product category"
            labelClassName="mb-1 text-sm text-gray-70 font-normal"
            inputBg="#EFF0FA"
            placeholder="Select category"
          />
        </div>
        <div className="w-1/2">
          <Dropdown
            value={productType}
            options={
              productCategory
                ? productCategoryList[productCategory].map((option) => ({
                  label: option,
                  value: option,
                }))
                : []
            }
            onChange={(value) => setProductType(value)}
            label="Product type"
            labelClassName="mb-1 text-sm text-gray-70 font-normal"
            inputBg="#EFF0FA"
            placeholder="Select type"
          />
        </div>
      </div>
      <div className="flex items-end justify-between gap-3">
        <div className="w-1/2">
          <Dropdown
            value={wareHouseLocation}
            options={wareHouseCountryList().map((option) => ({
              label: option.name,
              value: option.name,
            }))}
            onChange={(value) => setWareHouseLocation(value)}
            label="Preferred warehouse location"
            labelClassName="mb-1 text-sm text-gray-70 font-normal"
            inputBg="#EFF0FA"
            placeholder="Select country"
          />
        </div>
        <div className="w-1/2">
          <Dropdown
            value={province}
            options={selectedCountryStateOrProvince(wareHouseLocation).map(
              (option) => ({
                label: option.value,
                value: option.value,
              })
            )}
            onChange={(value) => setProvince(value)}
            labelClassName="mb-1 text-sm text-gray-70 font-normal"
            inputBg="#EFF0FA"
            placeholder="Select a state/province"
          />
        </div>
      </div>
      <div>
        <label className="mb-1 text-sm text-gray-70">
          Buy-back amount{" "}
          <QuestionHelpIcon
            details={
              <span>
                Amount to be requested <br /> Minimum - ₦ 5,000,000 <br />
                Maximum - ₦ 200,000,000
              </span>
            }
          />
        </label>
        <div className="flex items-start gap-2">
          <div className="bg-secondary-30 px-2 flex items-center justify-center rounded-md h-[56px]">
            <CurrencyToggle
              forCreditWallet
              newWalletsData={newWalletsData}
              isLoadingNewWallets={isLoadingNewWallets}
              refetchNewWallets={refetchNewWallets}
              businessId={business?._id}
              dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
              className="!text-gray-10 !text-base font-light gap-1 flex items-center justify-center w-[115px] !ml-2"
            />
          </div>
          <div className="w-full">
            <InputField
              onChange={(value) => {
                setBuyBackAmount(value);
              }}
              value={buyBackAmount}
              isValid={isBuyBackValid}
              showIcon={false}
              placeholder="Enter amount"
              wrapperClassName="max-w-full h-[56px]"
            />
            {!isBuyBackValid && (
              <p className="text-xs text-[#C01515] font-normal">
                This amount is less than or equal to the requested amount - ₦{" "}
                {formatMoney(buyBackMaxAmount)}
              </p>
            )}
          </div>
        </div>
      </div>
      <div>
        <Dropdown
          value={buyBackPeriod}
          options={buyBackPeriodList.map((option) => ({
            label: option,
            value: option,
          }))}
          onChange={(value) => setBuyBackPeriod(value)}
          label="Buy-back period"
          labelClassName="mb-1 text-sm text-gray-70 font-normal"
          inputBg="#EFF0FA"
          placeholder="Select Buy-back period"
        />
      </div>
    </>
  );
};

export default InventoryFinanceForm;
